export default __webpack_public_path__ + "static/media/September2009.be358975.png";